import React from "react";
import { ConfigProvider, Form, Input, Modal, theme } from "antd";
import type { FormInstance } from "antd";
import type { ProfileResponse } from "../../../types";

interface ProfileModalProps {
  open: boolean;
  form: FormInstance;
  profile: ProfileResponse | null;
  profileSaving: boolean;
  onCancel: () => void;
  onOk: () => void;
  onImageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ProfileModal: React.FC<ProfileModalProps> = ({
  open,
  form,
  profile,
  profileSaving,
  onCancel,
  onOk,
  onImageChange,
}) => (
  <ConfigProvider
    theme={{
      algorithm: theme.defaultAlgorithm,
      token: {
        colorBgElevated: "#ffffff",
        colorBgContainer: "#ffffff",
        colorText: "#1f2937",
        colorTextHeading: "#111827",
        colorBorder: "#d1d5db",
        colorBorderSecondary: "#e5e7eb",
      },
    }}
  >
    <Modal
      open={open}
      title="Edit Profile"
      onCancel={onCancel}
      onOk={onOk}
      okText={profileSaving ? "Saving..." : "Save"}
      confirmLoading={profileSaving}
      forceRender
      styles={{
        header: { background: "#ffffff" },
        body: { background: "#ffffff" },
      }}
    >
      <Form form={form} layout="vertical" className="admin-console__form">
        <Form.Item label="Profile Image" name="image">
          <div className="admin-console__profile-image-block">
            {(profile?.image || form.getFieldValue("image")) ? (
              <img
                src={profile?.image || form.getFieldValue("image")}
                alt="Profile"
                className="admin-console__profile-image"
              />
            ) : (
              <div className="admin-console__profile-image admin-console__profile-image--empty">
                No image
              </div>
            )}
            <label className="admin-console__profile-upload">
              <span>{profileSaving ? "Uploading..." : "Upload Image"}</span>
              <input type="file" accept="image/*" hidden onChange={onImageChange} />
            </label>
          </div>
        </Form.Item>
        <Form.Item label="Name" name="name" rules={[{ required: true }]}><Input /></Form.Item>
        <Form.Item label="Login" name="login" rules={[{ required: true }]}><Input /></Form.Item>
        <Form.Item label="Email" name="email"><Input /></Form.Item>
        <Form.Item label="Phone" name="phone"><Input /></Form.Item>
      </Form>
    </Modal>
  </ConfigProvider>
);
